module.exports = __webpack_public_path__ + "img/4-2.c8d60f9e.svg";